import React, { memo, Fragment } from "react";
import PropTypes from "prop-types";
//Components
import { Line, Text } from "../../atoms";
import { Section, ContentContainerMolecule, MarkdownRenderer } from "../../molecules";
import { withTheme } from 'styled-components'

const Article = memo(function Presentation({
  className,
  hasSubTitle,
  hasLine,
  hasBottomSpacing,
  data,
  showLangMessage,
  activeColor,
  gridClasses,
  hasContent,
  hasTitleDefault,
  defaultContent,
  hasTitle,
  theme
}) {

  const contentDefault = !hasContent ? defaultContent.content : data.content
  const content = data.content === '' ? 'Clique aqui ou selecione o lápis de edição para escrever o conteúdo' : contentDefault

  return (
    <Fragment>
      <Section
        autoFocus
        className={className}
        backgroundColor={theme.components.article.backgroundColor}
        hasBottomSpacing={hasBottomSpacing}
      >
        <div className="container">
          <div className="row no-gutters">
            <div className={gridClasses}>
              {hasSubTitle && (
                <Text
                  as="h2"
                  text={data.subTitle}
                  fontWeight="300"
                  marginBottom="5px"
                  size="large"
                  firstLetter="capitalize"
                />
              )}

              {!hasContent && showLangMessage && (
                <ContentContainerMolecule marginBottom="40px">
                  <Text color={activeColor}>
                    We are working in the translation of this content to
                    English. The original version of the content is presented
                    below.{" "}
                    {/* <Link
                        href={`${TranslationUrl}${devMode ? demoUrl : page}`}
                        target="_blank"
                      >
                        View translated page by Google
                      </Link> */}
                  </Text>
                </ContentContainerMolecule>
              )}
              {(hasTitle || hasTitleDefault) && (
                <Text
                  as="h1"
                  fontWeight="500"
                  text={!hasTitle ? defaultContent.title : data.title}
                  size="xLarge"
                  firstLetter="capitalize"
                />
              )}

              {hasLine && <Line color="#000" marginBottom="25px" />}

              <ContentContainerMolecule marginTop="40px">
                <MarkdownRenderer
                  content={content}
                  activeColor={activeColor}
                />
              </ContentContainerMolecule>
            </div>
          </div>
        </div>
      </Section>
    </Fragment>
  );
});

Article.defaultProps = {
  hasSubTitle: false,
  hasLine: false,
  data: {
    title: null,
    activeColor: null
  },
  hasBottomSpacing: true,
  showLangMessage: false,
};

Article.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    activeColor: PropTypes.string,
    content: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  hasSubTitle: PropTypes.bool,
  hasLine: PropTypes.bool,
  hasBottomSpacing: PropTypes.bool,
  showLangMessage: PropTypes.bool,
  gridClasses: PropTypes.string,
  hasContent: PropTypes.bool,
  hasTitleDefault: PropTypes.bool,
  defaultContent: PropTypes.object,
  hasTitle: PropTypes.bool
};

export default withTheme(Article);
